import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as faker from 'faker/locale/pt_BR';
import { Observable, of, forkJoin } from 'rxjs';
import { UrlApi } from '../Models/url-api.model';
import { Resposta } from '../Models/resposta.model';
import { RespostaWebAPI } from '../Models/resposta-web-api.model';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RespostaService {

  constructor(private http: HttpClient) { }

  post(model: Resposta): Observable<any> {
    const body = JSON.stringify(model);
    let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'  });
    return this.http.post(`${environment.apiUrl}resposta`, body, { headers: headers });
  }

  getPorParticipante(participanteid: number, perguntaid: number): Observable<RespostaWebAPI> {
    let headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'  });
    return this.http.get<RespostaWebAPI>(`${environment.apiUrl}resposta/porparticipante?participanteid=${participanteid}&perguntaid=${perguntaid}`, { headers: headers });
}
}
